import Permission from "../../permission";

export default class BulkPermissionCommand {
  public resources: string[];
  public granteeUserId: string;
  public note?: string;

  constructor(permissions: Permission[]) {
    const firstGranteeUserId = permissions[0].granteeUserId;
    const firstNote = permissions[0].note;

    const allSameGranteeUserId = permissions.every(p => p.granteeUserId === firstGranteeUserId);
    const allSameNote = permissions.every(p => p.note === firstNote);

    if (!allSameGranteeUserId || !allSameNote) {
      throw new Error("All permissions must have the same granteeUserId and note.");
    }

    this.resources = permissions.map(p => p.resource?.toJSONString());
    this.granteeUserId = firstGranteeUserId?.toString();
    this.note = firstNote;
  }
}
